import { useContext, useEffect, useRef, useState } from "react";
import Style from "./style.module.css";
import InnerLoader from "../../../../component/ui/loader/inner-loader";
import DataNotFound from "../../../../component/ui/loader/data-not-found";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import DynamicFilter from "../../../../component/table/filter-table/dynamic-filter";
import FilterFunnel01Icon from "../../../../component/icons/filter-funnel-01";
import { Table, TableBody, TableCard, TableCell, TableDepartmentTag, TableFilterReturn, TableFooter, TableHead, TableHeaderWrap, TableRow, } from "../../../../component/table/table-layout";
import CustomizeTabsPopup from "../../../../component/table/customize-table";
import Tooltip from "../../../../component/ui/tooltip";
import LayoutTopIcon from "../../../../component/icons/layout-top";
import moment from "moment";
import StatusChip from "../../../../component/ui/chip/status";
import AvatarProfile from "../../../../component/ui/profile";
import { TitleHeading } from "../../../../component/ui/layout";
import { GlobalContext } from "../../../../context/Context";
import { Brand, DateRange, Platform, TotalRoi } from "../../../../component/icons/filter-icon";

const DevicePerformance = () => {
  let { state } = useContext(GlobalContext);
  const apiCall = useApiCall();
  const [isLoading, setIsLoading] = useState(true);
  const [lists, setList] = useState([]);
  const [showModalFilterTable, setShowModalFilterTable] = useState(false);
  const [filterReturn, setFilterReturn] = useState([]);
  const [saveFilter, setSaveFilter] = useState([]);
  const [tableHeaders, setTableHeaders] = useState([]);
  const [showModalCustomizeTabs, setShowModalCustomizeTabs] = useState(false);
  const [footer, setFooter] = useState({});
  const [defaultRange, setDefaultRange] = useState("");

  useEffect(() => {
    getData({});
  }, []);

  const getData = async ({ filter = filterReturn, page = "" }) => {
    if (!page) {
      setIsLoading(true);
    }
    let extraUrl = `&page=${page}`;
    for (let i = 0; i < filter?.length; i++) {
      if (filter[i]?.selectedOpt == "between") {
        extraUrl += `&${filter[i]?.name}=${filter[i]?.value[0]}_${filter[i]?.value[1]}`;
      } else {
        extraUrl += `&${filter[i]?.name}=${filter[i]?.value}`;
      }
    }
    try {
      const res = await apiCall({
        method: "get",
        url: `get-ppc-merge-report?type=device${extraUrl}`,
      });
      setDefaultRange(res?.date_filter)
      setList(res.data);
      setTableHeaders(res.headers);
      setSaveFilter(res?.custom_filters);
      setFooter(res?.footer)
      setIsLoading(false);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const filterModalData = [
    {
      name: "brand_id",
      label: "Brand",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: state.getDropdowns.brandList,
      dropdownKey: "name",
      dropdownVal: "id",
      isMulti: true,
      Icon: Brand
    },
    {
      name: "device",
      label: "Device",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: [
        { label: "Desktop", val: "Desktop" },
        { label: "Mobile", val: "Mobile" },
      ],
      dropdownKey: "label",
      dropdownVal: "val",
      isMulti: true,
      Icon: TotalRoi
    },
    {
      name: "platform_id",
      label: "Platform",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: state.getDropdowns.platforms,
      dropdownKey: "name",
      dropdownVal: "id",
      isMulti: true,
      Icon: Platform
    },
    {
      name: "date_range",
      label: "Date Range",
      options: ["between"],
      selectedOpt: "between",
      value: "",
      type: "date",
      betweenType: "date",
      Icon: DateRange
    }
  ];

  const [hovered, setHovered] = useState(null)

  const hoveredRef = useRef(null);
  const [, forceRender] = useState(0);

  const handleHover = (id) => {
    hoveredRef.current = id;
    forceRender(v => v + 1); // one cheap render
  };

  const clearHover = () => {
    hoveredRef.current = null;
    forceRender(v => v + 1);
  };

  return (
    <>
      <div className={Style.leaveMainPage}>
        <TableFilterReturn
          filterReturn={(!filterReturn?.find(eachFilter => eachFilter?.name == "date_range")?.value?.length) ?
            [
              {
                "name": "date_range",
                "label": "Date Range",
                "selectedOpt": "is",
                "value": defaultRange,
                "isCrossDisable": true
              },
              ...filterReturn
            ]
            : filterReturn
          }
          onChange={(filters) => {
            console.log("filtersfiltersfilters", filters)
            setFilterReturn(filters);
            getData({ filter: filters });
          }}
        />
        <div className={Style.report_table__header}>
          <TitleHeading title={'Device-wise Performance Breakdown'} />

          <div className={Style.bpfl_action}>
            <Tooltip
              className={Style.bpfl_actionItems}
              content={"Table Filter"}
              position={"left center"}
            >
              <div
                className={`${Style.bpfl_actionBtn} ${filterReturn?.length ? Style.active : null
                  }`}
                onClick={() => {
                  setShowModalFilterTable(true);
                }}
              >
                <div className={Style.icon}>
                  <FilterFunnel01Icon />
                </div>
              </div>
            </Tooltip>
            <div className={`${Style.bpfl_action}`}>
              <Tooltip
                className={`${Style.bpfl_actionItems}`}
                content={"Customize Table"}
                position={"left center"}
              >
                <div
                  className={`${Style.bpfl_actionBtn}`}
                  onClick={() => {
                    setShowModalCustomizeTabs(true);
                  }}
                >
                  <div className={Style.icon}>
                    <LayoutTopIcon />
                  </div>
                </div>
              </Tooltip>
            </div>
          </div>
        </div>

        <div className={Style.LeaveBody}>
          {isLoading ? (
            <InnerLoader />
          ) : !lists?.length ? (
            <div className="w-full h-full flex items-center justify-center">
              <DataNotFound title={"Lists"} />
            </div>
          ) : (
            <>
              <TableCard>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell header sticky className={"min-w-[250px] max-w-[250px]"}>
                        <TableHeaderWrap>Device</TableHeaderWrap>
                      </TableCell>

                      <TableCell className={"min-w-[250px] max-w-[250px] !left-[250px]"} header sticky>
                        <TableHeaderWrap>
                          <span>Website</span>
                        </TableHeaderWrap>
                      </TableCell>

                      <TableCell className={"!left-[500px]"} header sticky>
                        <TableHeaderWrap>
                          <span>Platform</span>
                        </TableHeaderWrap>
                      </TableCell>

                      {tableHeaders?.map((eachHead, index) =>
                        eachHead.is_visible === 1 && eachHead?.show == 1 ? (
                          <TableCell header key={index}>
                            <TableHeaderWrap>
                              <span>{eachHead?.value}</span>
                            </TableHeaderWrap>
                          </TableCell>
                        ) : null
                      )}
                    </TableRow>
                  </TableHead>

                  {/*<TableBody>
                    {lists.map((device) => {
                      const deviceRowSpan = device?.websites?.reduce(
                        (sum, d) => sum + d?.platforms?.length,
                        0
                      );

                      let deviceRendered = false;

                      return device?.websites?.map((website) => {
                        let websiteRendered = false;

                        return website?.platforms?.map((platform, pIndex) => (
                          <TableRow key={`${device?.device?.name}-${website?.website?.w_id}-${pIndex}`} 
                            data-device={device?.device?.name}
                            // onMouseEnter={() => setHovered(device?.device?.name)}
                            // onMouseLeave={() => setHovered(null)}
                            onMouseOver={() => handleHover(device?.device?.name)}
                            onMouseOut={clearHover}
                            className={hoveredRef.current === device?.device?.name ? "!bg-[#EEF6FE]" : ""}
                          >
                            {!deviceRendered && (
                              <TableCell
                                sticky
                                rowSpan={deviceRowSpan}
                                className={`${hoveredRef.current === device?.device?.name ? "!bg-[#EEF6FE] !text-[#1E1E1E]" : ""}`}
                              >
                                <span className="whitespace-pre-wrap break-all">
                                  {device?.device?.name}
                                </span>
                              </TableCell>
                            )}

                            {!websiteRendered && (
                              <TableCell
                                rowSpan={website?.devices?.length}
                                className={`!left-[250px] ${hoveredRef.current === device?.device?.name ? "!bg-[#EEF6FE] !text-[#1E1E1E]" : ""}`} sticky
                                // className={hoveredRef.current === website.website.id ? "!bg-[#EEF6FE] text-[#1E1E1E]" : ""}
                              >
                                <span className="whitespace-pre-wrap break-all">
                                  {website?.website?.name}
                                </span>
                              </TableCell>
                            )}

                            <TableCell className={`!left-[500px] ${hoveredRef.current === device?.device?.name ? "!bg-[#EEF6FE] !text-[#1E1E1E]" : ""}`} sticky>{platform.name}</TableCell>

                            {tableHeaders?.map((eachHead, i) =>
                              eachHead.is_visible === 1 && eachHead?.show == 1 ? (
                                <TableCell>
                                  {(eachHead.key == "profit_loss" || eachHead.key == "fresh_roi" || eachHead.key == "total_roi") ? (
                                    <span
                                      className={
                                        platform[eachHead?.key]?.includes("-") ? "text-red-500" : (platform[eachHead?.key] == "$0.00" || platform[eachHead?.key] == "0.00%") ? "" : "text-green-500"
                                      }
                                    >
                                      {platform[eachHead?.key]}
                                    </span>
                                  )
                                  :
                                  platform[eachHead?.key]
                                  }
                                </TableCell>
                              ): null)
                            }

                            {(deviceRendered = true)}
                            {(websiteRendered = true)}
                          </TableRow>
                        ));
                      });
                    })}
                  </TableBody>*/}
                  <TableBody>
                    {lists.map((device) => {

                      // ✅ FIX 1: Correct device rowspan (sum of ALL platforms)
                      const deviceRowSpan = device?.websites?.reduce(
                        (sum, website) => sum + (website?.platforms?.length || 0),
                        0
                      );

                      return device?.websites?.map((website, websiteIndex) => {

                        // ✅ FIX 2: Website rowspan = number of platforms
                        const websiteRowSpan = website?.platforms?.length || 0;

                        return website?.platforms?.map((platform, platformIndex) => (
                          <TableRow
                            key={`${device?.device?.name}-${website?.website?.w_id}-${platformIndex}`}
                            data-device={device?.device?.name}

                            // ✅ FIX 3: Keep hover logic (no change)
                            onMouseOver={() => handleHover(device?.device?.name)}
                            onMouseOut={clearHover}
                            className={hoveredRef.current === device?.device?.name ? "!bg-[#EEF6FE]" : ""}
                          >

                            {/* ================= DEVICE CELL ================= */}
                            {/* ✅ FIX 4: Render ONLY ON FIRST website + FIRST platform */}
                            {websiteIndex === 0 && platformIndex === 0 && (
                              <TableCell
                                sticky
                                rowSpan={deviceRowSpan}
                                className={hoveredRef.current === device?.device?.name
                                  ? "!bg-[#EEF6FE] !text-[#1E1E1E]"
                                  : ""
                                }
                              >
                                <span className="whitespace-pre-wrap break-all">
                                  {device?.device?.name}
                                </span>
                              </TableCell>
                            )}

                            {/* ================= WEBSITE CELL ================= */}
                            {/* ✅ FIX 5: Render ONLY ON FIRST platform */}
                            {platformIndex === 0 && (
                              <TableCell
                                sticky
                                rowSpan={websiteRowSpan} // ✅ FIXED rowspan
                                className={`!left-[250px] ${hoveredRef.current === device?.device?.name
                                    ? "!bg-[#EEF6FE] !text-[#1E1E1E]"
                                    : ""
                                  }`}
                              >
                                <span className="whitespace-pre-wrap break-all">
                                  {website?.website?.name}
                                </span>
                              </TableCell>
                            )}

                            {/* ================= PLATFORM CELL ================= */}
                            <TableCell
                              sticky
                              className={`!left-[500px] ${hoveredRef.current === device?.device?.name
                                  ? "!bg-[#EEF6FE] !text-[#1E1E1E]"
                                  : ""
                                }`}
                            >
                              {platform.name}
                            </TableCell>

                            {/* ================= METRICS ================= */}
                            {tableHeaders?.map((eachHead) =>
                              eachHead.is_visible === 1 && eachHead.show == 1 ? (
                                <TableCell key={eachHead.key}>
                                  {(eachHead.key === "profit_loss" ||
                                    eachHead.key === "fresh_roi" ||
                                    eachHead.key === "total_roi") ? (
                                    <span
                                      className={
                                        platform[eachHead.key]?.includes("-")
                                          ? "text-red-500"
                                          : (platform[eachHead.key] === "$0.00" ||
                                            platform[eachHead.key] === "0.00%")
                                            ? ""
                                            : "text-green-500"
                                      }
                                    >
                                      {platform[eachHead.key]}
                                    </span>
                                  ) : (
                                    platform[eachHead.key]
                                  )}
                                </TableCell>
                              ) : null
                            )}
                          </TableRow>
                        ));
                      });
                    })}
                  </TableBody>


                  <TableFooter>
                    <TableRow>
                      <TableCell header sticky className="!font-bold !bg-[#f6f7f7]"></TableCell>
                      <TableCell header sticky className="!font-bold !bg-[#f6f7f7] !left-[250px]"></TableCell>
                      <TableCell header sticky className="!font-bold !bg-[#f6f7f7] !left-[500px]"></TableCell>
                      {tableHeaders?.map((head, hIdx) => {
                        return (
                          head.is_visible === 1 && head.show == 1 ? (
                            <TableCell header key={`footer_cell_${hIdx}`} className="!font-bold !bg-[#f6f7f7]">
                              {head.key === "status" ? (
                                <StatusChip color={footer[head.key] === "Active" ? "green" : "red"}>
                                  {footer[head.key] || "--"}
                                </StatusChip>
                              ) : head.key === "assigned_user_department" ? (
                                <TableDepartmentTag title={footer[head.key]} />
                              ) : (head.key == "profit_loss" || head.key == "fresh_roi" || head.key == "total_roi") ? (
                                <span
                                  className={
                                    footer[head.key]?.includes("-") ? "text-red-500" : (footer[head.key] == "$0.00" || footer[head.key] == "0.00%") ? "" : "text-green-500"
                                  }
                                >
                                  {footer[head.key]}
                                </span>
                              ) : (
                                footer[head.key] ?? "-"
                              )}
                            </TableCell>
                          ) : null
                        )
                      }

                      )}
                    </TableRow>
                  </TableFooter>
                </Table>
              </TableCard>
            </>
          )}
        </div>
      </div>

      {showModalFilterTable && (
        <DynamicFilter
          data={filterModalData}
          onClose={() => setShowModalFilterTable(false)}
          returnData={filterReturn}
          onSave={(filters) => {
            getData({ filter: filters });
            setShowModalFilterTable(false);
            setFilterReturn(filters);
          }}
          saveFilter={saveFilter}
          apiUrl="get-ppc-merge-report?type=device"
        />
      )}

      {showModalCustomizeTabs && (
        <CustomizeTabsPopup
          data={tableHeaders}
          onClose={() => {
            setShowModalCustomizeTabs(false);
          }}
          onPreview={(updatedHeaders) => {
            setTableHeaders(updatedHeaders);
          }}
          onSave={(saveHeaders) => {
            setTableHeaders(saveHeaders);
          }}
          apiUrl="get-ppc-merge-report?type=device"
        />
      )}
    </>
  );
};

export default DevicePerformance;
